import { default as empRaisesAndDeductionsTypes } from "./types";

const {
  FETCH_EMP_RAISES_AND_DEDUCTIONS_REQUEST,
  FETCH_EMP_RAISES_AND_DEDUCTIONS_SUCCESS,
  FETCH_EMP_RAISES_AND_DEDUCTIONS_FAILURE,
} = empRaisesAndDeductionsTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMP_RAISES_AND_DEDUCTIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_EMP_RAISES_AND_DEDUCTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_EMP_RAISES_AND_DEDUCTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
